// Handles a change to the deposit amount or the type of deposit
export default function handleDepositChange(
  e,
  deposit,
  setDeposit,
  methodChange,
  dateChange,
) {
  // The value sent in containing the amount, or method or date.
  let value = 0;
  // Sets the deposit to a temp value. It contains the method, date
  // and the amount.
  const depositTemp = { ...deposit };
  // If the user is changing how the deposit occured.
  if (methodChange) {
    // method of payment
    value = e.target.value;
    depositTemp.method = value;
    // The location of the pickup
    depositTemp.location = "";
    // The date the food was distributed.
    depositTemp.collectedDate = "";
  }
  // If the date of the deposit changes.
  else if (dateChange) {
    // date of deposit
    value = e;
    if (value === null) return;

    const formattedDate = new Date(value);
    const y = formattedDate.getFullYear();
    const m = formattedDate.getMonth() + 1;
    const d = formattedDate.getDate();

    value = `${y}-${m < 10 ? "0" : ""}${m}-${d < 10 ? "0" : ""}${d}`;

    depositTemp.date = value;
  }
  // Otherwise it's the amount of the deposit.
  else {
    // amount
    if (e.target.value === "") {
      value = "";
    } else {
      value = parseFloat(e.target.value);
    }
    depositTemp.amount = value;
  }

  setDeposit(depositTemp);

  return {
    deposit,
    setDeposit,
    handleDepositChange,
  };
}
